import { TApplicationState } from 'shared/types/redux';
import { EDealType } from 'shared/types/wantType';

/* istanbul ignore next */
export const selectDealType = (state: TApplicationState): EDealType => {
  return state.dealType.value;
};
